import { render, staticRenderFns } from "./cooperList.vue?vue&type=template&id=52a376ef&"
import script from "./cooperList.vue?vue&type=script&lang=js&"
export * from "./cooperList.vue?vue&type=script&lang=js&"
import style0 from "./cooperList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports